import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  os: "ios",
  screenWidth: 3200,
  screenHeight: 3200,
  x: 0,
  y: 0,
  scale: 100,
  width: 320,
  height: 640,
  orientation: "portrait",
  mode: "layout",
  showHighlight: true,
};

const platformSlice = createSlice({
  name: 'platform',
  initialState,
  reducers: {
    changeOs(state, action) {
      state.os = action.payload;
    },
    changeScale(state, action) {
      state.scale = Number(action.payload);
    },
    changeXY(state, action) {
      state.x = Number(action.payload.x);
      state.y = Number(action.payload.y);
    },
    changePlatformSize(state, action) {
      state.width = Number(action.payload.width);
      state.height = Number(action.payload.height);
    },
    changeOrientation(state, action) {
      state.orientation = action.payload;
    },
    changeMode(state, action) {
      //layout or action
      state.mode = action.payload;
    },
    toggleHighlight(state) {
      state.showHighlight = !state.showHighlight;
    }
  },
});

export const { changeOs, changeScale, changeXY, changeOrientation, changePlatformSize, changeMode, toggleHighlight } = platformSlice.actions;
export default platformSlice.reducer;
